var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"target"},[_vm._v("CURRENT CORE TARGET: --------- DEADLINE: XX/XX/XXXX")])}
var staticRenderFns = []

export { render, staticRenderFns }